// extracted by mini-css-extract-plugin
export default {"dragLayer":"DragPreviewLayer-dragLayer-lJxaW"};